import React, {useEffect, useState} from "react";
import sanityClient from "../client";
import NavBar from "./NavBar";
import NavBarMobile from "./NavBarMobile";
import { useMediaQuery } from "@uidotdev/usehooks";


export default function WorkPackage() {
    const isSmallDevice = useMediaQuery("only screen and (max-width : 768px)");
    const allDevices = useMediaQuery("only screen and (min-width : 769px)");
    const [workPackageData, setworkPackageData] = useState(null);

    useEffect(()=> {
        sanityClient.fetch(`*[_type == "workPackage"]{
            naslov,
            opis,
            link,
            dugme
        }`).then((data) => setworkPackageData(data))
        .catch(console.error);
    }, []);
    return (
        <>
                    {allDevices && (
            <NavBar />
        )}
          {isSmallDevice && (
              <NavBarMobile/>
        )}
        <main className="bg-white-100 min-h-screen p-12">
            <section className="container mx-auto">
                <h1 className="text-4xl flex pb-8">Work Package</h1>
                <section className="grid grid-cols-1 gap-4">
                    {workPackageData && workPackageData.map((workPackage, index) => (

                    
                    <article className="relative pt-2 pb-4 border-b border-gray-200" key={workPackage}>
                        <h3 className="text-blue-600 text-2xl hover:text-blue-700">
                                {workPackage.naslov}
                        </h3>
                        <p className="text-gray-700 py-4 dark:text-gray-400 mb-2">{workPackage.opis}</p>
                    </article>
                    ))}
                </section>
            </section>
        </main>
        </>
    )
}